import React from 'react';
import Skeleton from '../../../../component/skeletonBase';
import '../../style.css';
import { Block } from '@comp/crRender';

const ProviderDetailsSkeleton = ( { isRender } ) => {
    return (
        <Block isRender={!!isRender} className="provider-container">
            {/* Header Skeleton */}
            <div className="provider-header">
                <Skeleton 
                    variant="rounded" 
                    width="110px" 
                    height="110px" 
                    className="provider-logo"
                />
                <div style={{ flex: 1 }}>
                    <Skeleton 
                        variant="text" 
                        width="60%" 
                        height="2rem" 
                        style={{ marginBottom: '10px' }}
                    />
                    <Skeleton 
                        variant="rounded" 
                        width="150px" 
                        height="1.5rem" 
                    />
                </div>
            </div>

            {/* Summary Skeleton */}
            <div className="provider-summary">
                <Skeleton variant="text" width="100%" height="1rem" style={{ marginBottom: '10px' }} />
                <Skeleton variant="text" width="100%" height="1rem" style={{ marginBottom: '10px' }} />
                <Skeleton variant="text" width="85%" height="1rem" />
            </div>

            {/* Grid Cards Skeleton */}
            <div className="provider-grid">
                {/* Contact Info Card */}
                <div className="provider-card">
                    <Skeleton variant="text" width="40%" height="1.4rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="100%" height="1rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="90%" height="1rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="95%" height="1rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="85%" height="1rem" />
                </div>

                {/* Service Categories Card */}
                <div className="provider-card">
                    <Skeleton variant="text" width="50%" height="1.4rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="100%" height="1rem" style={{ marginBottom: '10px' }} />
                    <Skeleton variant="text" width="90%" height="1rem" style={{ marginBottom: '10px' }} />
                    <Skeleton variant="text" width="85%" height="1rem" />
                </div>

                {/* Accreditations Card */}
                <div className="provider-card">
                    <Skeleton variant="text" width="45%" height="1.4rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="100%" height="1rem" style={{ marginBottom: '10px' }} />
                    <Skeleton variant="text" width="95%" height="1rem" style={{ marginBottom: '10px' }} />
                    <Skeleton variant="text" width="80%" height="1rem" />
                </div>

                {/* Certifications Card */}
                <div className="provider-card">
                    <Skeleton variant="text" width="48%" height="1.4rem" style={{ marginBottom: '18px' }} />
                    <Skeleton variant="text" width="100%" height="1rem" style={{ marginBottom: '10px' }} />
                    <Skeleton variant="text" width="88%" height="1rem" style={{ marginBottom: '10px' }} />
                    <Skeleton variant="text" width="92%" height="1rem" />
                </div>
            </div>

            {/* Keywords Section Skeleton */}
            <div className="keyword-section">
                <Skeleton variant="text" width="30%" height="1.5rem" style={{ marginBottom: '18px' }} />
                <div className="keywords">
                    <Skeleton variant="rounded" width="100px" height="36px" style={{ borderRadius: '20px' }} />
                    <Skeleton variant="rounded" width="120px" height="36px" style={{ borderRadius: '20px' }} />
                    <Skeleton variant="rounded" width="90px" height="36px" style={{ borderRadius: '20px' }} />
                    <Skeleton variant="rounded" width="110px" height="36px" style={{ borderRadius: '20px' }} />
                    <Skeleton variant="rounded" width="130px" height="36px" style={{ borderRadius: '20px' }} />
                    <Skeleton variant="rounded" width="95px" height="36px" style={{ borderRadius: '20px' }} />
                </div>
            </div>
        </Block>
    );
};

export default ProviderDetailsSkeleton;

